import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleDownSmall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-down-small, dropdown, caret"><path d="M15.25 11H8.75L12 15L15.25 11Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconChevronTriangleDownSmall;
